import React ,{useState} from 'react'
import KontakDiv from '../components/logo/KontakDiv'
import Navbar from '../components/Navbar/Index'
import Sidebar from '../components/Sidebar/Index'
import Contact from './home/Contact'

const MyContact = () => {
    const [isOpen,setOpen] = useState(false)
    const toggle = () => {
        setOpen(!isOpen)
    }
    return (
        <div>
            <KontakDiv/>
            <Sidebar isOpen={isOpen} toggle={toggle}/>
            <Navbar toggle={toggle}/>
            <Sidebar/>
            <Contact/>
        </div>
    )
}

export default MyContact
